import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[notDraggableContent]',
  standalone: true,
})
export class NotDraggableContentDirective {
  @HostListener('mousedown', ['$event'])
  preventDragging(event: MouseEvent): void {
    event.stopPropagation();
  }
}
